import React from 'react';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { EmailItemModel } from 'forms/shared/types';
import { AccordionItemProps } from 'components/Form/Accordion/types';
import PVQEmail from 'components/Form/PVQEmail';
import { DeepSafePartial } from 'types/types';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  emailBranchQuestionLabel?: string
  showEmailUnknown?: boolean
  includeEmailType?: boolean
  showAnotherEmail: {(): void}
  removeThisEmail: {(idx : number): void}
  showAccordianActions?: boolean,
  preventRepeatQuestions?:boolean
}

interface ItemProps
  extends Props,
  Partial<EmailItemModel>,
    Omit<AccordionItemProps, 'name'> {}

export default class EmailCollectionItem extends ValidationElement<ItemProps> {
  update = (queue: DeepSafePartial<EmailItemModel>) => {
    this.props.onUpdate({
      Has: this.props.Has,
      Email: this.props.Email,
      ...queue,
    });
  };

  onUpdateEmail = (values: Partial<EmailItemModel['Email']>) => {
    this.update({ Email: values });
  };

  showAnotherEmail = () => {
    this.props.showAnotherEmail?.();
  };

  removeThisEmail = () => {
    this.props.removeThisEmail?.(this.props?.$index || 0);
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;
    return (
      <PVQEmail
        attribute={`${attribute}.Email`}
        name="Item"
        bind
        required={this.props.required}
        includeEmailType={this.props.includeEmailType}
        onUpdate={this.onUpdateEmail}
        onError={this.props.onError}
        emailFieldTitle={this.props.emailFieldTitle}
        {...this.props.Email}
        showEmailUnknown={this.props.showEmailUnknown && this.props.$index === 0}
        showAccordianActions={this.props.showAccordianActions}
        showRemoveItem={!!this.props.showRemoveItem}
        preventRepeatQuestions={!!(this.props.preventRepeatQuestions && this.props.$index > 0)}
        showAnotherEmail={this.showAnotherEmail}
        removeThisEmail={this.removeThisEmail}
      />
    );
  }
}

EmailCollectionItem.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  emailFieldTitle: 'What is the email?',
  Email: {},
  Has: {},
  showEmailUnknown: false,
  emailUnknown: false,
  showAccordianActions: false,
  preventRepeatQuestions: false,
  showAnotherEmail: () => {},
  removeThisEmail: (index: number) => {},
  dontKnowThisEmail: () => {},
};
